function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9484 18.653L1.82337 0.652999C1.74308 0.578666 1.64291 0.529261 1.53506 0.51079C1.42721 0.492319 1.31631 0.505578 1.21585 0.548955C1.1154 0.592332 1.0297 0.663958 0.969191 0.755127C0.908679 0.846296 0.875957 0.95308 0.875 1.0625V26.9375C0.875512 27.0476 0.908285 27.1552 0.969271 27.2469C1.03026 27.3387 1.11678 27.4105 1.21815 27.4536C1.31952 27.4967 1.43129 27.5091 1.53965 27.4894C1.64801 27.4696 1.74822 27.4186 1.82788 27.3425L9.3305 20.0975C9.64503 19.7937 10.0655 19.6242 10.5027 19.625H20.5625C20.6752 19.625 20.7853 19.5912 20.8786 19.5279C20.9719 19.4647 21.044 19.3748 21.0855 19.27C21.1271 19.1653 21.1363 19.0505 21.1118 18.9404C21.0874 18.8304 21.0304 18.7303 20.9484 18.653"
});

function SvgIcAreaCursor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAreaCursor);
export default ForwardRef;